import {
    FieldDataParameter,
    FieldParameter,
    SwitchParameter,
    SectionField,
    TextArrayField
} from "../../../Fields"

import { TableHeadersField } from "../../../Fields/TableHeadersField" // TODO: default export works - regular export in index file not
import { ValidationRulesField } from "../../../Fields/ValidationRulesField"

import {
    ParameterObjectTemplate,
    ChoicesParameterTemplate,
    SubfieldsParameterTemplate,
    TableHeaderParameterTemplate,
    FieldTemplate
} from "../../../Templates"

import {
    TextWidget,
    CheckboxWidget,
    TextareaWidget,
    SelectWidget,
    MultipleChoiceWidget
} from "../../../Widgets"

const generalFields = {
    fieldName: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextWidget
        }
    },
    fieldId: {
        "ui:widget": "hidden",
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextWidget
        }
    },
    description: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextWidget
        }
    },
    group: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextWidget
        }
    },
    humanInstructions: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextareaWidget
        }
    },
    advices: {
        data: {
            "ui:field": TextArrayField,
            "ui:options": {
                addButtonLabel: "Add advice"
            }
        },
        editable: {
            "ui:widget": "hidden"
        }
    },
    examples: {
        data: {
            "ui:field": TextArrayField,
            "ui:options": {
                addButtonLabel: "Add example"
            }
        },
        editable: {
            "ui:widget": "hidden"
        }
    },
    antiExamples: {
        data: {
            "ui:field": TextArrayField,
            "ui:options": {
                addButtonLabel: "Add anti-example"
            }
        },
        editable: {
            "ui:widget": "hidden"
        }
    },
    validationRules: {
        data: {
            "ui:field": ValidationRulesField,
            "ui:options": {
                addButtonLabel: "Add validation rule"
            }
        },
        editable: {
            "ui:widget": "hidden"
        }
    },
    required: {
        "ui:widget": "hidden"
    },
    visible: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": CheckboxWidget
        }
    },
    status: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": SelectWidget
        }
    },
    aliases: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": MultipleChoiceWidget
        }
    },
    options: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": SelectWidget,
            "ui:FieldTemplate": FieldTemplate,
            contentType: {
                "ui:widget": "hidden"
            },
            type: {
                "ui:widget": "hidden"
            },
            requireAnnotations: {
                "ui:field": SwitchParameter,
                selection: {
                    "ui:widget": CheckboxWidget
                },
                annotationType: {
                    "ui:widget": SelectWidget,
                    "ui:ObjectFieldTemplate": ParameterObjectTemplate
                }
            },
            multipageTables: {
                "ui:field": FieldParameter,
                "ui:widget": CheckboxWidget
            },
            searchScope: {
                "ui:field": FieldParameter,
                "ui:widget": SelectWidget,
                "ui:disabled": true
            },
            applyRedaction: {
                "ui:field": SwitchParameter,
                selection: {
                    "ui:widget": CheckboxWidget
                },
                redactionType: {
                    "ui:widget": SelectWidget,
                    "ui:ObjectFieldTemplate": ParameterObjectTemplate
                }
            },
            isAbstractive: {
                "ui:field": FieldParameter,
                "ui:widget": CheckboxWidget
            },
            minimum: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            maximum: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            choices: {
                "ui:ArrayFieldTemplate": ChoicesParameterTemplate,
                items: {
                    "ui:widget": TextWidget
                }
            },
            maxSelections: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            minLength: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            maxLength: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            customTableHeaders: {
                "ui:field": TableHeadersField
            },
            entityType: {
                "ui:field": FieldParameter,
                "ui:widget": SelectWidget
            },
            blockedEntities: {
                "ui:field": FieldParameter,
                "ui:widget": MultipleChoiceWidget
            },
            allowedEntities: {
                "ui:field": FieldParameter,
                "ui:widget": MultipleChoiceWidget
            },
            datasetIntegration: {
                datasetUri: {
                    "ui:field": FieldParameter,
                    "ui:widget": TextWidget
                },
                allowNewValues: {
                    "ui:field": FieldParameter,
                    "ui:widget": CheckboxWidget
                },
                nMatches: {
                    "ui:field": FieldParameter,
                    "ui:widget": TextWidget
                },
                matchingThreshold: {
                    "ui:field": FieldParameter,
                    "ui:widget": TextWidget
                },
                outputColumnName: {
                    "ui:field": FieldParameter,
                    "ui:widget": TextWidget
                }
            }
        }
    }
}

export const uiSchema = {
    ...generalFields,
    "ui:ObjectFieldTemplate": ParameterObjectTemplate,
    subfields: {
        "ui:field": SectionField,
        data: {
            "ui:ArrayFieldTemplate": SubfieldsParameterTemplate,
            items: generalFields
        }
    },
    "ui:order": [
        "fieldId",
        "fieldName",
        "options",
        "description",
        "required",
        "status",
        "aliases",
        "humanInstructions",
        "advices",
        "examples",
        "antiExamples",
        "validationRules"
    ]
}

export const tableHeaderUISchema = {
    id: {
        "ui:FieldTemplate": TableHeaderParameterTemplate,
        "ui:widget": TextWidget
    },
    title: {
        "ui:FieldTemplate": TableHeaderParameterTemplate,
        "ui:widget": TextWidget,
        "ui:autofocus": true
    },
    required: {
        "ui:widget": "hidden"
    },
    aliases: {
        "ui:widget": "hidden"
    },
    options: {
        contentType: {
            "ui:widget": "hidden"
        },
        type: {
            "ui:widget": "hidden"
        },
        minimum: {
            "ui:FieldTemplate": TableHeaderParameterTemplate,
            "ui:widget": TextWidget
        },
        maximum: {
            "ui:FieldTemplate": TableHeaderParameterTemplate,
            "ui:widget": TextWidget
        },
        choices: {
            "ui:ArrayFieldTemplate": ChoicesParameterTemplate,
            items: {
                "ui:widget": TextWidget
            }
        },
        maxSelections: {
            "ui:FieldTemplate": TableHeaderParameterTemplate,
            "ui:widget": TextWidget
        },
        minLength: {
            "ui:FieldTemplate": TableHeaderParameterTemplate,
            "ui:widget": TextWidget
        },
        maxLength: {
            "ui:FieldTemplate": TableHeaderParameterTemplate,
            "ui:widget": TextWidget
        }
    }
}

export const advancedCustomUiSchema = {
    "ui:ObjectFieldTemplate": ParameterObjectTemplate,
    "ui:order": [
        "fieldId",
        "fieldName",
        "options",
        "description",
        "required",
        "status",
        "aliases",
        "humanInstructions",
        "advices",
        "examples",
        "antiExamples",
        "validationRules"
    ],
    fieldName: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextWidget
        }
    },
    fieldId: {
        "ui:widget": "hidden",
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextWidget
        }
    },
    description: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextWidget
        }
    },
    group: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextWidget
        }
    },
    humanInstructions: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": TextareaWidget
        }
    },
    advices: {
        "ui:widget": "hidden"
    },
    examples: {
        "ui:widget": "hidden"
    },
    antiExamples: {
        "ui:widget": "hidden"
    },
    validationRules: {
        "ui:widget": "hidden"
    },
    required: {
        "ui:widget": "hidden"
    },
    visible: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": CheckboxWidget
        }
    },
    status: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": SelectWidget
        }
    },
    aliases: {
        "ui:widget": "hidden"
    },
    options: {
        "ui:field": FieldDataParameter,
        data: {
            "ui:widget": SelectWidget,
            "ui:FieldTemplate": FieldTemplate,
            contentType: {
                "ui:widget": "hidden"
            },
            type: {
                "ui:widget": "hidden"
            },
            requireAnnotations: {
                "ui:field": SwitchParameter,
                selection: {
                    "ui:widget": CheckboxWidget
                },
                annotationType: {
                    "ui:widget": SelectWidget,
                    "ui:ObjectFieldTemplate": ParameterObjectTemplate
                }
            },
            multipageTables: {
                "ui:field": FieldParameter,
                "ui:widget": CheckboxWidget
            },
            searchScope: {
                "ui:field": FieldParameter,
                "ui:widget": SelectWidget,
                "ui:disabled": true
            },
            applyRedaction: {
                "ui:widget": "hidden"
            },
            minimum: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            maximum: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            choices: {
                "ui:ArrayFieldTemplate": ChoicesParameterTemplate,
                items: {
                    "ui:widget": TextWidget
                }
            },
            maxSelections: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            minLength: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            maxLength: {
                "ui:field": FieldParameter,
                "ui:widget": TextWidget
            },
            customTableHeaders: {
                "ui:field": TableHeadersField
            },
            entityType: {
                "ui:field": FieldParameter,
                "ui:widget": SelectWidget
            },
            blockedEntities: {
                "ui:field": FieldParameter,
                "ui:widget": MultipleChoiceWidget
            },
            allowedEntities: {
                "ui:field": FieldParameter,
                "ui:widget": MultipleChoiceWidget
            },
            datasetIntegration: {
                datasetUri: {
                    "ui:field": FieldParameter,
                    "ui:widget": TextWidget
                },
                allowNewValues: {
                    "ui:field": FieldParameter,
                    "ui:widget": CheckboxWidget
                },
                nMatches: {
                    "ui:field": FieldParameter,
                    "ui:widget": TextWidget
                },
                matchingThreshold: {
                    "ui:field": FieldParameter,
                    "ui:widget": TextWidget
                },
                outputColumnName: {
                    "ui:field": FieldParameter,
                    "ui:widget": TextWidget
                }
            }
        }
    }
}
